<template>
  <div class="menu">
    <div class="item">
      <a class="about" href="javascript:void(0)"
        ><i class="icon icon-about" />关于纵购
        <div class="animation-box">
          <div class="detail">
            <a href="/about/about" class="li"><p>关于纵购</p></a>
            <a href="/about/course" class="li"><p>企业历程</p></a>
            <a href="/about/culture" class="li"><p>企业文化</p></a>
            <a href="/about/trajectory" class="li"><p>企业动态</p></a>
            <a href="/about/cooperation" class="li"><p>合作伙伴</p></a>
            <a href="/about/contact" class="li"><p>联系我们</p></a>
          </div>
        </div>
      </a>
    </div>
    <a class="item" href="javascript:void(0)" @click="goto('/')"
      ><i class="icon icon-shop" />我的店铺</a
    >
    <a class="item" href="javascript:void(0)" @click="goto('/sale')"
      ><i class="icon icon-card" />销售中心</a
    >
    <a class="item" href="javascript:void(0)" @click="goto('/stock')"
      ><i class="icon icon-stock" />库存管理</a
    >
    <a v-show="/^(undefined|1|2|3|5|6)$/.test(user.shop_status)" class="item" href="/join">
      <i class="icon icon-next" />我要入驻
    </a>
    <a class="item" href="tel:400-930-2128"><i class="icon icon-phone" />咨询:400-930-2128</a>
  </div>
</template>

<script>
import { syncToken, getUser, getAccessToken } from '@/utils'
export default {
  name: 'PageNav',
  data() {
    return {
      user: {}
    }
  },
  created() {
    this.user = getUser()
  },

  methods: {
    goto(baseUrl) {
      const token = getAccessToken()

      if (!token) {
        syncToken()
        this.$router.push(`/login?form=${process.env.VUE_APP_SELLER_ORIGIN}${baseUrl}`)
        return
      }

      if (this.user.shop_status !== 0) {
        this.$router.push(`/join`)
        return
      }

      if (this.user.shop_status === 0 && this.user.show_welcome === 1) {
        this.$router.push(`/join`)
        return
      }

      window.location.href = `${process.env.VUE_APP_SELLER_ORIGIN}${baseUrl}`
    }
  }
}
</script>

<style lang="postcss">
.menu {
  float: right;
  padding-top: 34px;
  position: relative;
  margin-right: 10px;
  .item {
    display: inline-block;
    padding: 9px 15px 9px 0;

    .icon {
      vertical-align: middle;
      margin-right: 5px;
      font-size: 14px;
    }
    .icon-about {
      font-size: 18px;
    }
    .about {
      display: inline-block;
      height: 40px;
      position: relative;
      .animation-box {
        position: absolute;
        top: 38px;
        left: -30px;
        overflow: hidden;
        height: 0px;
        transition: height 1s cubic-bezier(0.25, 0.1, 0.25, 5);
        z-index: 666;
        .detail {
          top: 44px;
          left: -12px;
          margin: auto;
          background: #fff;
          width: 138px;
          text-align: center;
          .li {
            height: 45px;
            line-height: 45px;
            display: block;
            border-bottom: 1px solid #eeeeee;
          }
          .li:last-child p {
            border-bottom: none;
          }
          .li:hover {
            color: #fabe00;
          }
          .li:hover p {
            background: rgba(250, 250, 250);
            border-bottom: 2px solid #fabe00;
          }
        }
      }
    }
    .about:hover .animation-box {
      height: 280px;
    }
    .about:hover {
      color: #fff;
    }
  }
  .item:last-child {
    padding-right: 0;
  }
  .item:hover {
    color: #fff;
  }
}
</style>
